import { useState } from "react";
import logo from "./logo.svg";
import "./App.css";
import hypertune from "../lib/hypertune";

export default function App(): React.ReactElement {
  const [, setForceUpdate] = useState(0);

  return (
    <div className="App">
      <header className="App-header">
        <img src={logo} className="App-logo" alt="logo" />
        <p>{hypertune.root({}).headline({ fallback: "Fallback headline" })}</p>
        <button
          type="button"
          onClick={() => {
            setForceUpdate((s) => s + 1);
          }}
        >
          Force re-render
        </button>
      </header>
    </div>
  );
}
